export default __webpack_public_path__ + "4b4445214bff825751acfca0ab4c0567.svg";